import fetch from 'isomorphic-fetch'

export const fetchApi = async (input: RequestInfo, init: RequestInit) => {
  const response = await fetch(input, init)
  if (!response.ok) {
    throw response
  }
  return response
}
